import { useState, useEffect } from "react";
import { IFilters } from "../types/interfaces/IFilters";
import { IFiltersResponse } from "../types/interfaces/IFiltersResponse";


/**
 * useGetFilters Hook
 * 
 * This custom hook handles the API fetch from the backend controller to retrieve directory filters data.
 * This hook is ONLY used in DirectoryContext (Provider).
 * 
 * @returns {IFiltersResponse} The response object containing the filters data, loading state, and error state.
 */
export default function useGetFilters(): IFiltersResponse {
    const [data, setData] = useState<IFilters>();
    const [loading, setLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const directory_filters_data_api = process.env.REACT_APP_API_GET_DIRECTORY_FILTERS ?? '';

    useEffect(() => {
        setLoading(true);
        setIsError(false);
        const controller = new AbortController();
        const fetchFilters = async () => {
            console.log("fetchFilters method called");
            try {
                const response = await fetch(directory_filters_data_api);
                if (response.ok) {
                    console.log("response.ok")
                    const filtersResponse = await response.json();
                    if (filtersResponse == null) {
                        console.log("filtersResponse is null");
                    }
                    setData(filtersResponse.Data);

                }
                else {
                    console.log("response NOT ok")
                    setIsError(true);
                }
            }
            catch (e: any) {
                console.log("caught error: " + e);
                setIsError(true);
            }
            finally {
                setLoading(false);
            }
        };

        fetchFilters();
        return () => controller.abort();
    }, [directory_filters_data_api]);

    return { data, loading, isError };
}